import { GenericLazyString } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { CategoryBrowseDateFilter } from '../CategoryBrowseDateFilter';
import { CategoryBrowseLocationAutocomplete } from '../CategoryBrowseLocationAutocomplete';
import './SeasonalHeaderContainer.scss';

interface SeasonalHeaderContainerProps {
    title: GenericLazyString;
    locale: string;
    backgroundImagePath: string;
}

export const SeasonalHeaderContainer: React.FunctionComponent<
    SeasonalHeaderContainerProps
> = (props) => {
    const { title, locale, backgroundImagePath } = props;
    return (
        <div
            className="seasonal__header-container"
            data-testid="seasonal-container"
            style={{
                backgroundImage: `url(${backgroundImagePath})`,
            }}
        >
            <Typography as="h1" className="seasonal__text ">
                {title}
            </Typography>
            <section className="seasonal__filters">
                <CategoryBrowseLocationAutocomplete />
                <CategoryBrowseDateFilter locale={locale} />
            </section>
        </div>
    );
};
